import { render, staticRenderFns } from "./ActionRevisarRechazo.vue?vue&type=template&id=29998e62&lang=pug"
import script from "./ActionRevisarRechazo.vue?vue&type=script&lang=js"
export * from "./ActionRevisarRechazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports